<template lang="pug">
    ib-application(layout="full", row, :translations="translations")
        router-view
</template>

<script>
import ProductsExchanges from './components/ProductsExchanges.vue'

    export default {
        components: {
            ProductsExchanges
        },
        data() {
            return {
                translations: _i18n.translations,
            };
        }
    }
</script>

<style lang="less">
.ga-view {
    height: calc(~'100vh - 240px');
}
</style>